'use strict'

module.exports = {
  full: address => {
    const lines = []
    lines.push(`〒${address.postalCode}`)
    lines.push(`${address.state}${address.city}${address.town}`)
    lines.push(`${address.line1}${address.line2 ? address.line2 : ''}`)
    return lines
  },

  full_inline: address => {
    const lines = []
    const parts = []
    parts.push(`〒${address.postalCode}`)
    parts.push(`${address.state}${address.city}${address.town}`)
    parts.push(`${address.line1}${address.line2 ? address.line2 : ''}`)
    lines.push(parts.join(', '))
    return lines
  },

  street: address => [`${address.line1}${address.line2 ? address.line2 : ''}`],
  city: address => [`${address.state}${address.city}${address.town}`]
}
